import { createContext } from 'react'

export const ServerDateContext = createContext(null)
